/**
 * * 获取当前网络状态
 * @Mixin
 * @data netWorkData {Object} 包含当前最新的网络状态信息
 */
export default {
  data() {
    return {
      netWorkData: {
        onLine: navigator.onLine,
      },
    };
  },
  computed: {
    netWorkState: {
      get() {
        return this.netWorkData;
      },
      set(state) {
        this.netWorkData = {
          ...this.netWorkData,
          ...state,
        };
      },
    },
  },
  watch: {
    'netWorkData.onLine': {
      handler(newValue) {
        this.$store.commit('set_global_status', {
          target: 'online',
          value: newValue
        })
      }
    }
  },
  mounted() {
    window.addEventListener('online', this.onOnline);
    window.addEventListener('offline', this.onOffline);
    this.connection = this.getConnection();
    // eslint-disable-next-line
    this.connection && this.connection.addEventListener('change', this.onConnectionChange);
    this.onConnectionChange();
  },
  beforeDestroy() {
    window.removeEventListener('online', this.onOnline);
    window.removeEventListener('offline', this.onOffline);
    // eslint-disable-next-line
    this.connection && this.connection.removeEventListener('change', this.onConnectionChange);
  },
  methods: {
    getConnection() {
      const nav = navigator;
      if (typeof nav !== 'object') return null;
      return nav.connection || nav.mozConnection || nav.webkitConnection;
    },
    getConnectionProperty() {
      const c = this.getConnection();
      if (!c) return {};
      return {
        rtt: c.rtt,
        type: c.type,
        saveData: c.saveData,
        downlink: c.downlink,
        downlinkMax: c.downlinkMax,
        effectiveType: c.effectiveType,
      };
    },
    onConnectionChange() {
      this.netWorkState = {
        ...this.getConnectionProperty(),
      };
    },
    onOnline() {
      this.netWorkState = {
        onLine: true,
        since: new Date(),
      };
    },
    onOffline() {
      this.netWorkState = {
        onLine: false,
        since: new Date(),
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/network/index.js